import {
ApplicationConfig,
ClassProvider,
FactoryProvider,
provideBrowserGlobalErrorListeners,
provideZoneChangeDetection,
ValueProvider,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import {
HTTP_INTERCEPTORS,
provideHttpClient,
withInterceptorsFromDi,
} from '@angular/common/http';
import { OAuthStorage,provideOAuthClient } from 'angular-oauth2-oidc';
import { provideToastr } from 'ngx-toastr';
import { environment,OAuthConfig } from '../environments/environment';
import { APIBaseURI,AppConfigToken,BaseURI } from './app.config.tokens';
import { routes } from './app.routes';
import { ProgressInterceptor } from './customizations-of-internals/progress-interceptor';
import { AuthGuard,RoleGuard } from './guards';
import {
AuthenticationService,
AuthenticationServiceToken,
CorrFilterService,
CorrFilterServiceToken,
ErrorService,
ErrorServiceToken,
LogServiceToken,
MapperService,
MapperServiceToken,
ProgressService,
ProgressServiceToken,
RepositoryService,
RepositoryServiceToken,
RoleService,
RoleServiceToken,
ScrollService,
ScrollServiceToken,
} from './services';

import { BreadcrumbService } from 'ng-breadcrumb';
import { UserResolver } from './resolvers';

import { provideAnimations } from '@angular/platform-browser/animations';

export function storageFactory(): OAuthStorage {
  return localStorage;
}
export function getAccessToken() {
  return storageFactory().getItem('access_token');
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptorsFromDi()),
    provideToastr(),
    AuthGuard,
    RoleGuard,
    UserResolver,
    provideOAuthClient(),
    provideAnimations(),
    {
      provide: OAuthStorage,
      useFactory: storageFactory,
    },

    <ValueProvider>{
      provide: 'authConfig',
      useValue: OAuthConfig,
    },
    <ValueProvider>{
      provide: BaseURI,
      useValue: environment.appConfig.BaseURI,
    },
    <ValueProvider>{
      provide: APIBaseURI,
      useValue: environment.appConfig.APIBaseURI,
    },
    <ValueProvider>{
      provide: AppConfigToken,
      useValue: environment.appConfig,
    },
    <FactoryProvider>{
      provide: LogServiceToken,
      useFactory: environment.appConfig.logFactory,
    },

    <ClassProvider>{
      provide: AuthenticationServiceToken,
      useClass: AuthenticationService,
    },
    <ClassProvider>{
      provide: AuthenticationService,
      useClass: AuthenticationService,
    },
    <ClassProvider>{
      provide: RoleServiceToken,
      useClass: RoleService,
    },
    <ClassProvider>{
      provide: RepositoryServiceToken,
      useClass: RepositoryService,
    },
    <ClassProvider>{
      provide: CorrFilterServiceToken,
      useClass: CorrFilterService,
    },
    <ClassProvider>{
      provide: MapperServiceToken,
      useClass: MapperService,
    },
    <ClassProvider>{
      provide: ProgressServiceToken,
      useClass: ProgressService,
    },
    <ClassProvider>{
      provide: ScrollServiceToken,
      useClass: ScrollService,
    },
    <ClassProvider>{
      provide: BreadcrumbService,
      useClass: BreadcrumbService,
    },
    <ClassProvider>{
      provide: ErrorServiceToken,
      useClass: ErrorService,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ProgressInterceptor, multi: true },
  ],
};
